import { createContext, useContext } from 'react';

/**
 * Context to detect if content is rendered inside WebsitePreviewWrapper.
 * Used by split layout to determine scroll behavior:
 * - true: Container scroll (preview panels - sidebar editor, full page modal)
 * - false: Document scroll (guest /for/ page)
 */
const IsPreviewWrapperContext = createContext(false);

export const IsPreviewWrapperProvider = IsPreviewWrapperContext.Provider;
export const useIsPreviewWrapper = () => useContext(IsPreviewWrapperContext);
